import { useMediaQuery } from "@base/model/hooks/useMediaQuery";
import { Sparkles } from "lucide-react";
import { Suspense, lazy } from "react";

const DotLottieReact = lazy(() => import("@lottiefiles/dotlottie-react").then((m) => ({ default: m.DotLottieReact })));

const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";
const REFINE_LOTTIE_SRC = "https://lottie.host/3cc3191e-850d-4322-ae36-a3db562304de/lqmKL1Q5h8.lottie";

/** 부모는 `relative`여야 한다. */
export function RefineLoadingOverlay() {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);

  if (isDesktop) return <DesktopRefineLoading />;
  return <MobileRefineLoading />;
}

function MobileRefineLoading() {
  return (
    <>
      <div className="absolute inset-0 z-10 rounded-md bg-white/70" />
      <Suspense fallback={null}>
        <DotLottieReact
          src={REFINE_LOTTIE_SRC}
          loop
          autoplay
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 20 }}
        />
      </Suspense>
    </>
  );
}

/**
 * PC는 넓은 편집기에 Lottie를 늘이면 어색하므로, 가운데에 작은 스피너와 안내 문구를 둔다.
 * 색은 Home AI Summary 카드와 같은 AI 보라 톤을 쓴다.
 */
function DesktopRefineLoading() {
  return (
    <output
      aria-live="polite"
      className="flex absolute inset-0 z-10 flex-col gap-3 justify-center items-center rounded-md bg-white/80 backdrop-blur-[2px]"
    >
      <span className="flex relative justify-center items-center w-11 h-11 rounded-circle bg-[#faf6fe]">
        <span className="absolute inset-0 rounded-circle border-2 border-[#eddcfa] border-t-[#a55ae9] animate-spin" />
        <Sparkles width={18} height={18} className="text-[#a55ae9] animate-pulse" aria-hidden="true" />
      </span>
      <span className="flex flex-col gap-1 items-center text-center">
        <span className="font-medium text-gray-1000 text-body3">Refining your report with AI…</span>
        <span className="text-gray-500 text-label3">This usually takes a few seconds. You can undo it afterward.</span>
      </span>
    </output>
  );
}
